import PropTypes from "prop-types";
import * as Yup from "yup";
import {openSuccessDialog} from "../../utils/ui-components/pop-ups/SuccessDialog";
import {Form, Formik} from "formik";
import {Button, CircularProgress, Grid, IconButton, InputAdornment} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import LockIcon from "@mui/icons-material/Lock";
import {gridSpacing} from "../../store/constants";
import TextField from "../../utils/ui-components/FormsUI/TextField";
import {useState} from "react";
import { UserService } from "../../assets/_services/user-service";

ChangeReportUserPassword.propTypes = {
    setOpen: PropTypes.func.isRequired,
    id: PropTypes.number.isRequired,
    fetchData: PropTypes.func.isRequired,
    search: PropTypes.string.isRequired,
};

export interface ReportUserListValues {
    password: string;
    confirmPassword: string;
};

function ChangeReportUserPassword({setOpen, fetchData, id, search}: any) {

    const INITIAL_VALUES : ReportUserListValues = {
        password : "",
        confirmPassword : ""
    }
    const [isLoading,setIsLoading] = useState(false)
    const [passwordShow, setPasswordShow] = useState({
        password: "",
        showPassword: false,
        confirmPassword: "",
        showConfirmPassword: false,
    });

    const FORM_VALIDATION = Yup.object().shape({
        password: Yup.string().max(255).required("Please enter your new password"),
        confirmPassword: Yup.string()
            .oneOf([Yup.ref("password")], "Your passwords do not match.").required('Please confirm your password'),
    });

    const changePassword = (itemData: ReportUserListValues, setSubmitting: (isSubmitting: boolean) => void) => {
        setIsLoading(true)
        let formData = {
            userId : id,
            password : itemData.password,
        }

        UserService.updateReportUserPassword(formData).then(
            response => {
                if (response.isSuccess) {
                    openSuccessDialog("Success", response.data.comment);
                    setOpen(false);
                    fetchData(search);
                    setIsLoading(false)
                }else{
                    setSubmitting(false);
                    setIsLoading(false)
                }
            }
        );
    };

    const handleClickShowPassword = () => {
        setPasswordShow({
            ...passwordShow,
            showPassword: !passwordShow.showPassword,
        });
    };

    const handleClickShowConfirmPassword = () => {
        setPasswordShow({
            ...passwordShow,
            showConfirmPassword: !passwordShow.showConfirmPassword,
        });
    };

    return (
        <Formik
            initialValues={INITIAL_VALUES}
            validationSchema={FORM_VALIDATION}
            onSubmit={(values: ReportUserListValues, {setSubmitting}) => {
                changePassword(values,setSubmitting)
            }}
        >
            {({values, dirty, isSubmitting, isValid, setFieldValue}) => (
                <Form>
                    <Grid container columnSpacing={gridSpacing}>
                        <Grid item md={6}  xs={12}>
                            <TextField
                                type={passwordShow.showPassword ? "text" : "password"}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <LockIcon/>
                                        </InputAdornment>
                                    ),
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowPassword}
                                                edge="end"
                                            >
                                                {passwordShow.showPassword ? (
                                                    <VisibilityOff/>
                                                ) : (
                                                    <Visibility/>
                                                )}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                                name="password"
                                label="Password"
                                placeholder="Password"
                                required
                            />
                        </Grid>
                        <Grid item md={6} xs={12}>
                            <TextField
                                type={passwordShow.showConfirmPassword ? "text" : "password"}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <LockIcon/>
                                        </InputAdornment>
                                    ),
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowConfirmPassword}
                                                edge="end"
                                            >
                                                {passwordShow.showConfirmPassword ? (
                                                    <VisibilityOff/>
                                                ) : (
                                                    <Visibility/>
                                                )}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                                name="confirmPassword"
                                label="Confirm Password"
                                placeholder="Confirm Password"
                                required
                            />
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Grid item xs={12} sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                                py: 2,
                            }}>
                                <Button
                                    color="primary"
                                    variant="contained"
                                    type="submit"
                                    disabled={!dirty || isSubmitting || !isValid}
                                >
                                    {isLoading && <CircularProgress size={'20px'} sx={{mr:1, color:'gray' }} />} Update User Password
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Form>
            )}
        </Formik>
    );
}

export default ChangeReportUserPassword;